import {FC, lazy, Suspense} from 'react'
import {Navigate, Route, Routes} from 'react-router-dom'
import {MasterLayout} from '../../_metronic/layout/MasterLayout'
import TopBarProgress from 'react-topbar-progress-indicator'
import {DashboardWrapper} from '../pages/dashboard/DashboardWrapper'
import {MenuTestPage} from '../pages/MenuTestPage'
import {getCSSVariableValue} from '../../_metronic/assets/ts/_utils'
import {WithChildren} from '../../_metronic/helpers'
import BuilderPageWrapper from '../pages/layout-builder/BuilderPageWrapper'
import ReceptionPage from '../modules/apps/pages/reception/ReceptionPage'
import DocumentRequestPage from '../modules/apps/pages/document-request/DocumentRequestPage'
import ReportPage from '../modules/apps/pages/reports/ReportPage'

const PrivateRoutes = () => {
  const ProfilePage = lazy(() => import('../modules/profile/ProfilePage'))
  const AccountPage = lazy(() => import('../modules/accounts/AccountPage'))
  const MenuPage = lazy(() => import('../modules/apps/pages/menus/MenuPage'))
  const UsersPage = lazy(() => import('../modules/apps/pages/users/UsersPage'))
  const AccessGroupPage = lazy(() => import('../modules/apps/pages/accessgroups/AccessGroupPage'))
  const BusinessGroupPage = lazy(
    () => import('../modules/apps/pages/businessgroup/BusinessGroupPage')
  )
  const CompanyPage = lazy(() => import('../modules/apps/pages/company/CompanyPage'))
  const DepartamentPage = lazy(() => import('../modules/apps/pages/departament/DepartamentPage'))
  const CostCenterPage = lazy(() => import('../modules/apps/pages/costcenter/CostCenterPage'))
  const ProtocolTypePage = lazy(
    () => import('../modules/apps/pages/protocol-type/ProtocolTypePage')
  )
  const ProtocolPage = lazy(() => import('../modules/apps/pages/protocol/ProtocolPage'))
  const ProposalPage = lazy(() => import('../modules/apps/pages/proposals/ProposalPage'))
  const DocumentTypePage = lazy(
    () => import('../modules/apps/pages/document-type/DocumentTypePage')
  )
  const SearchPage = lazy(() => import('../modules/apps/pages/search/SearchPage'))

  return (
    <Routes>
      <Route element={<MasterLayout />}>
        {/* Redirect to Dashboard after success login/registartion */}
        <Route path='auth/*' element={<Navigate to='/dashboard' />} />
        {/* Pages */}
        <Route path='dashboard' element={<DashboardWrapper />} />
        <Route
          path='builder'
          element={
            <SuspensedView>
              <BuilderPageWrapper />
            </SuspensedView>
          }
        />
        <Route path='menu-test' element={<MenuTestPage />} />
        {/* Lazy Modules */}
        <Route
          path='crafted/pages/profile/*'
          element={
            <SuspensedView>
              <ProfilePage />
            </SuspensedView>
          }
        />

        <Route
          path='crafted/account/*'
          element={
            <SuspensedView>
              <AccountPage />
            </SuspensedView>
          }
        />
        <Route
          path='apps/protocols/*'
          element={
            <SuspensedView>
              <ProtocolPage />
            </SuspensedView>
          }
        />
        <Route
          path='apps/proposals/*'
          element={
            <SuspensedView>
              <ProposalPage />
            </SuspensedView>
          }
        />

        <Route
          path='apps/document-requests/*'
          element={
            <SuspensedView>
              <DocumentRequestPage />
            </SuspensedView>
          }
        />

        <Route
          path='apps/reports/*'
          element={
            <SuspensedView>
              <ReportPage />
            </SuspensedView>
          }
        />

        <Route
          path='apps/receptions/*'
          element={
            <SuspensedView>
              <ReceptionPage />
            </SuspensedView>
          }
        />

        <Route
          path='apps/users/*'
          element={
            <SuspensedView>
              <UsersPage />
            </SuspensedView>
          }
        />
        <Route
          path='apps/access-groups/*'
          element={
            <SuspensedView>
              <AccessGroupPage />
            </SuspensedView>
          }
        />
        <Route
          path='apps/menus/*'
          element={
            <SuspensedView>
              <MenuPage />
            </SuspensedView>
          }
        />
        <Route
          path='apps/business-groups/*'
          element={
            <SuspensedView>
              <BusinessGroupPage />
            </SuspensedView>
          }
        />

        <Route
          path='apps/companies/*'
          element={
            <SuspensedView>
              <CompanyPage />
            </SuspensedView>
          }
        />

        <Route
          path='apps/departaments/*'
          element={
            <SuspensedView>
              <DepartamentPage />
            </SuspensedView>
          }
        />

        <Route
          path='apps/cost-center/*'
          element={
            <SuspensedView>
              <CostCenterPage />
            </SuspensedView>
          }
        />

        <Route
          path='apps/protocol-types/*'
          element={
            <SuspensedView>
              <ProtocolTypePage />
            </SuspensedView>
          }
        />

        <Route
          path='apps/document-types/*'
          element={
            <SuspensedView>
              <DocumentTypePage />
            </SuspensedView>
          }
        />

        <Route
          path='apps/search/*'
          element={
            <SuspensedView>
              <SearchPage />
            </SuspensedView>
          }
        />

        {/* Page Not Found */}
        <Route path='*' element={<Navigate to='/error/404' />} />
      </Route>
    </Routes>
  )
}

const SuspensedView: FC<WithChildren> = ({children}) => {
  const baseColor = getCSSVariableValue('--bs-primary')
  TopBarProgress.config({
    barColors: {
      '0': baseColor,
    },
    barThickness: 1,
    shadowBlur: 5,
  })
  return <Suspense fallback={<TopBarProgress />}>{children}</Suspense>
}

export {PrivateRoutes}
